<template>
  <div class="register-form">
    <form name="form" @submit.prevent="handleRegister">
      <legend class="uk-legend uk-text-center">Registration</legend>
      <div class="uk-margin">
        <div class="uk-forms-controls">
          <label class="uk-form-label">First Name</label>
          <input
            :class="{
              'uk-input': true,
              'uk-form-danger': errors.has('firstName')
            }"
            type="text"
            name="firstName"
            v-model="user.firstName"
            v-validate="`required|min:1|max:50`"
          >
        </div>
        <div v-if="errors.has('firstName')" class="uk-text-danger uk-text-small">{{errors.first('firstName')}}</div>
      </div>
      <div class="uk-margin">
        <div class="uk-forms-controls">
          <label class="uk-form-label">Last Name</label>
          <input
            :class="{
              'uk-input': true,
              'uk-form-danger': errors.has('lastName')
            }"
            type="text"
            name="lastName"
            v-model="user.lastName"
            v-validate="`required|min:1|max:50`"
          >
        </div>
        <div v-if="errors.has('lastName')" class="uk-text-danger uk-text-small">{{errors.first('lastName')}}</div>
      </div>
      <div class="uk-margin">
        <div class="uk-forms-controls">
          <label class="uk-form-label">Email</label>
          <input
            :class="{
              'uk-input': true,
              'uk-form-danger': errors.has('email')
            }"
            type="text"
            name="email"
            v-model="user.email"
            v-validate="`required|email|max:50`"
          >
        </div>
        <div v-if="errors.has('email')" class="uk-text-danger uk-text-small">{{errors.first('email')}}</div>
      </div>
      <div class="uk-margin">
         <div class="uk-form-controls">
            <label class="uk-form-label">Password</label>
            <input
              :class="{
                'uk-input': true,
                'uk-form-danger': errors.has('password')
              }"
              type="password"
              name="password"
              v-model="user.password"
              v-validate="`required|min:8|max:20`"
            >
         </div>
         <div v-if="errors.has('password')" class="uk-text-danger uk-text-small">{{errors.first('password')}}</div>
      </div>
      <div class="uk-margin">
        <div class="uk-forms-controls">
           <label class="uk-form-label">You Order code</label>
           <input
            :class="{
                'uk-input': true,
                'uk-form-danger': errors.has('payCode')
            }"
            name="payCode"
            type="text"
            v-model="user.payCode"
            v-validate="`required|min:3|max:30`"
            >
        </div>
        <div v-if="errors.has('payCode')" class="uk-text-danger uk-text-small">{{errors.first('payCode')}}</div>
      </div>
      <div class="uk-margin">
        <div class="uk-grid-small uk-child-width-auto uk-grid">
            Are you representing an organization?
            <label><input class="uk-radio" type="radio" name="radio2" :value="true" v-model="user.isEnterprise" :checked="user.isEnterprise"> Yes</label>&nbsp;&nbsp;
            <label><input class="uk-radio" type="radio" name="radio2" :value="false" v-model="user.isEnterprise" :checked="user.isEnterprise"> No</label>
        </div>
      </div>
      <div class="uk-margin" v-if="user.isEnterprise">
        <div class="uk-forms-controls">
           <label class="uk-form-label">Company name</label>
           <input class="uk-input" name="organizationName" type="text" v-model="user.organizationName">
        </div>
      </div>
      <div class="uk-margin uk-text-center">
         <div uk-spinner v-show="loading"></div>
         <button class="uk-button uk-button-primary uk-width-1-1" v-show="!loading">Register</button>
      </div>
      <p v-if="message" class="uk-text-center uk-text-small" :class="successful ? 'uk-text-success' : 'uk-text-danger'">{{message}}</p>
      <p class="text-center link">Already registered?  <router-link to="/login">Log in</router-link></p>
    </form>
  </div>
</template>


<script>
import User from '../models/user';
export default {
    name: 'Register',
    data() {
      return {
        user: new User('', '', '', '', '', '', '', ''),
        loading: false,
        message: '',
        successful: false,
      }
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        }
    },
    mounted() {
        if (this.loggedIn) {
            this.$router.push({ name: 'dashboard'});
        }
        
    },
    methods: {
      handleRegister() {
            this.message = '';
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    this.loading = true;
                    this.user.roles = ["user"];
                    this.$store.dispatch('auth/register', this.user).then(
                        data => {
                            console.log(data);
                            this.message = data.message;
                            this.successful = true;
                            this.loading = false;
                            setTimeout(() =>  this.$router.push({ name: 'login' }), 3000);
                        },
                        error => {
                            this.message = 
                            (error.response && error.response.data.message) ||
                            error.message || error.toString();
                            this.loading = false;
                        }
                    );
                }
            });
        }
    },
}
</script>

<style>

</style>